export const taskTypes = {
  1: 'Актуализация контактов',
  2: 'Поиск транспорта на погрузку',
}

export const titlesTasks = [
  { span: 3, name: 'Создание' },
  { span: 5, name: 'Тип и назначение' },
  { span: 6, name: 'Описание' },
  { span: 3, name: 'Звонки' },
  { span: 2, name: 'Статус' },
  { span: 3, name: 'Действие' },
]

export const titlesContacts = [
  { span: 5, name: 'ФИО' },
  { span: 3, name: 'Статус' },
  { span: 8, name: 'Описание' },
  { span: 3, name: 'Звонки' },
  { span: 3, name: 'Действие' },
]

export const taskStatuses = {
  0: 'Новая задача',
  1: 'В процессе',
  2: 'Завершена',
}

export const callTypes = {
  0: 'Входящий',
  1: 'Исходящий',
}

export const callStatuses = {
  1: 'успешный звонок',
  2: 'просит перезвонить',
  3: 'занято',
  4: 'не взял трубку',
}

export const contactStatuses = {
  0: 'не звонили',
  1: 'успешный звонок',
  2: 'отложен',
  3: 'не дозвонились',
}

export const taskMenu = [
  { text: 'Добавить задание', command: 'addItem' },
  { text: 'Контакты', command: 'goToСontacts' },
]

export const contactMenu = [
  { text: 'Добавить контакт', command: 'addItem' },
  { text: 'Список заданий', command: 'goToTasks' },
]
